import { render } from "./ContractsOverview.vue?vue&type=template&id=09608708&scoped=true&ts=true"
import script from "./ContractsOverview.vue?vue&type=script&lang=ts"
export * from "./ContractsOverview.vue?vue&type=script&lang=ts"

import "./ContractsOverview.vue?vue&type=style&index=0&id=09608708&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09608708"]])

export default __exports__